import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import Loader from '../../../utils/Loader';
import { yupResolver } from "@hookform/resolvers/yup";
import { useShowQualificationQuery,useUpdateQualificationMutation} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        qualification: Yup.string().required("qualification fields is required"),
    });
      const {
        data: showQualification,
        isLoading: isGetLoading,
      } =  useShowQualificationQuery({  params:props['id']});

      const [updateQualification] = useUpdateQualificationMutation();
      const qualificationData= showQualification?.data[0];
      var  defaultValues={
        qualification:qualificationData?.qualification
      };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[showQualification,reset]) 
      
    const updateQualificationList = (values,e) => {
        updateQualification({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Qualification</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Qualification</h5>
                        <form onSubmit={handleSubmit(updateQualificationList)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Qualification</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("qualification")} className="form-control" />
                                <span className="text-danger">{errors.qualification?.message}</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                                <button type="submit" className="btn btn-warning">Save changes</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}